import { defaultOptions } from '../options';
export const createURL = (endpoint, query, options = defaultOptions) => {
    const urlStr = options.url === undefined ? defaultOptions.url : options.url;
    let url = new URL(`${urlStr}/${endpoint}`);
    if (options.client !== undefined) {
        query.client = options.client;
    }
    url.search = new URLSearchParams(query).toString();
    return url;
};
